<template>
    <div class="dropdown-button-container" >
        <vs-button class="btnx" type="filled"
            color="primary" icon-pack="material-icons" :icon="icon"
            @click="$emit('click')">
            {{ label }}
        </vs-button>
        <vs-dropdown>
            <vs-button class="btn-drop py-3" type="filled" icon="expand_more"></vs-button>
            <vs-dropdown-menu>
                <slot>
                </slot>
            </vs-dropdown-menu>
        </vs-dropdown>
    </div>
</template>

<script>
    export default {
        props: {
            label: String,
            icon: String,
        },
    }
</script>

<style lang="scss" scoped>

.dropdown-button-container {
  display: flex;
  align-items: center;

  .btnx {
    border-radius: 5px 0px 0px 5px;
    font-size: 9pt;
  }

  .btn-drop {
    border-radius: 0px 5px 5px 0px;
    border-left: 1px solid rgba(255, 255, 255, .2);
  }
}
</style>